import _ from 'lodash'
import L from 'leaflet'

/**
 * Create drawing layers, controls, and events on a map.
 */
class GeofenceDrawing {
  constructor(map) {
    this.map = map
    this.editableLayer = null
    this.drawableControls = null
    this.editableControls = null
    this.fence = null
    this.$input = $('input[name="notify_geofence_coordinates"]')
    this.buttons = {}
  }

  get drawable() {
    return this.editableLayer.getLayers().length === 0
  }

  /**
   * Add custom buttons to the map.
   */
  addButtons() {
    this.buttons['showGeofence'] = L.easyButton(
      '<i class="mdi mdi-shape-outline mdi-18px"></i>',
      this.onClickShowGeofence.bind(this),
      __('Center on geofence')
    ).addTo(this.map)
  }

  /**
   * Options for drawing simple polygons.
   */
  getDrawOptions(allowDraw = true) {
    const options = {
      position: 'topright',
      draw: {
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: '#ffaf00', // Color the shape will turn when intersects
            message: __('Geofence must be a single enclosure.'), // Message that will show when intersect
          },
          shapeOptions: {
            color: '#8862e0',
          },
        },
        // Disable toolbar item by setting it to false
        polyline: false,
        circle: false,
        rectangle: false,
        marker: false,
        circlemarker: false,
      },
      edit: {
        featureGroup: this.editableLayer, //REQUIRED!!
        remove: true,
        poly: {
          allowIntersection: false,
        },
      },
    }

    if ( ! allowDraw) {
      options.draw = false
    }

    return options
  }

  /**
   * Get the language object for the Leaflet.draw plugin.
   */
  getDrawLocal() {
    return {
      draw: {
          toolbar: {
              actions: {
                  title: __('Cancel geofence'),
                  text: __('Cancel'),
              },
              finish: {
                  title: __('Finish geofence'),
                  text: __('Finish'),
              },
              undo: {
                  title: __('Delete last point drawn'),
                  text: __('Delete last point'),
              },
              buttons: {
                  polyline: __('Draw a polyline'),
                  polygon: __('Draw a geofence'),
                  rectangle: __('Draw a rectangle'),
                  circle: __('Draw a circle'),
                  marker: __('Draw a marker'),
                  circlemarker: __('Draw a circlemarker'),
              },
          },
          handlers: {
              circle: {
                  tooltip: {
                      start: __('Click and drag to draw circle.'),
                  },
                  radius: __('Radius'),
              },
              circlemarker: {
                  tooltip: {
                      start: __('Click map to place circle marker.'),
                  },
              },
              marker: {
                  tooltip: {
                      start: __('Click map to place marker.'),
                  },
              },
              polygon: {
                  tooltip: {
                      start: __('Click to start drawing geofence.'),
                      cont: __('Click to continue drawing geofence.'),
                      end: __('Click first point to complete geofence.'),
                  },
              },
              polyline: {
                  error: __('<strong>Error:</strong> shape edges cannot cross!'),
                  tooltip: {
                      start: __('Click to start drawing line.'),
                      cont: __('Click to continue drawing line.'),
                      end: __('Click last point to finish line.'),
                  },
              },
              rectangle: {
                  tooltip: {
                      start: __('Click and drag to draw rectangle.'),
                  },
              },
              simpleshape: {
                  tooltip: {
                      end: __('Release mouse to finish drawing.'),
                  },
              }
          }
      },
      edit: {
          toolbar: {
              actions: {
                  save: {
                      title: __('Save changes'),
                      text: __('Save'),
                  },
                  cancel: {
                      title: __('Cancel editing, discards all changes'),
                      text: __('Cancel'),
                  },
                  clearAll: {
                      title: __('Clear geofences'),
                      text: __('Clear'),
                  },
              },
              buttons: {
                  edit: __('Edit geofence'),
                  editDisabled: __('No geofence to edit'),
                  remove: __('Delete geofence'),
                  removeDisabled: __('No geofence to delete'),
              },
          },
          handlers: {
              edit: {
                  tooltip: {
                      text: __('Drag handles to edit geofence.'),
                      subtext: __('Click cancel to undo changes.'),
                  },
              },
              remove: {
                  tooltip: {
                      text: __('Click on a feature to remove.'),
                  },
              },
          },
      },
    }
  }

  /**
   * Create the drawing layers, controls, and events.
   */
  initializeDrawing() {
    this.addButtons()

    // Initialise the FeatureGroup to store editable layers
    this.editableLayer = new L.FeatureGroup()
    this.map.addLayer(this.editableLayer)

    // Initialise the draw control and pass it the FeatureGroup of editable layers
    console.log(L.drawLocal)
    // L.drawLocal.draw.toolbar.buttons.polygon = "Blah blah blah"
    L.drawLocal = _.defaults(this.getDrawLocal(), L.drawLocal)
    console.log(L.drawLocal)
    this.drawableControls = new L.Control.Draw(this.getDrawOptions(true))
    this.editableControls = new L.Control.Draw(this.getDrawOptions(false))
    this.map.addControl(this.drawableControls)

    this.map.on(L.Draw.Event.CREATED, this.onCreated.bind(this))
    this.map.on(L.Draw.Event.DELETED, this.onDeleted.bind(this))
    this.map.on(L.Draw.Event.EDITED, this.onEdited.bind(this))
  }

  /**
   * Switch controls between the drawing/editable control sets.
   */
  changeControls(drawable = true) {
    const toAdd = drawable ? this.drawableControls : this.editableControls
    const toRemove = drawable ? this.editableControls : this.drawableControls
    this.map.removeControl(toRemove)
    this.map.addControl(toAdd)
    drawable ? this.buttons['showGeofence'].disable() : this.buttons['showGeofence'].enable()
  }

  /**
   * Center on the geofence when the show geofence button is clicked.
   */
  onClickShowGeofence() {
    this.fitFence(false)
  }

  /**
   * Upon the creation of a polygon disable drawing and save fence coords.
   */
  onCreated(e) {
    this.editableLayer.addLayer(e.layer)
    this.setFence(e.layer.toGeoJSON().geometry)
    console.log('Geofence Created', this.fence)
    this.changeControls(false)
  }

  /**
   * Upon the deletion of a polygon enable drawing and save fence coords.
   */
  onDeleted(e) {
    if (this.editableLayer.getLayers().length === 0) {
      this.setFence(null)
      console.log('Geofence Deleted', this.fence)
      this.changeControls(true)
    }
  }

  /**
   * Upon the edit of a polygon save the new fence coordinates.
   */
  onEdited(e) {
    try {
      this.setFence(e.layers.toGeoJSON().features[0].geometry)
    }
    catch (e) {
      this.setFence(null)
    }
    console.log('Geofence Edited', this.fence)
  }

  /**
   * Add the fence polygon to the editable layer.
   */
  drawFence() {
    const fenceValue = this.$input.val()
    const fence = fenceValue === '' ? null : JSON.parse(fenceValue)
    this.editableLayer.clearLayers()
    if (fence === null) {
      this.changeControls(true)
    }
    else {
      // console.log('Restoring polygon', fence)
      fence.forEach((polygon) => {
        const polygonLayer = L.polygon(polygon).addTo(this.editableLayer)
      })
      this.changeControls(false)
    }
    this.fence = fence
  }

  /**
   * Fit the map to the geofence.
   */
  fitFence(fly = true) {
    const polygonLayers = this.editableLayer.getLayers()
    if (polygonLayers.length > 0) {
      const fenceBounds = polygonLayers[0].getBounds().pad(0.1)
      if (fly) {
        this.map.flyToBounds(fenceBounds)
      }
      else {
        this.map.fitBounds(fenceBounds, { animate: false })
      }
    }
  }

  /**
   * Save the fence coordinates from a geoJSON geometry object.
   */
  setFence(geometry) {
    if (geometry === null) {
      this.fence = null
    }
    else {
      this.fence = geometry.coordinates.map((polygon) => {
        return L.GeoJSON.coordsToLatLngs(polygon)
      })
    }
    this.setFenceInput(this.fence)
  }

  /**
   * Pass the geofence coordinates to the hidden input
   */
  setFenceInput(fence) {
    if (fence === null) {
      this.$input.val('')
    }
    else {
      const fenceValue = JSON.stringify(fence)
      this.$input.val(fenceValue)
    }
  }
}

export { GeofenceDrawing }
